import { simpleSet } from '@r/reducers/utils';

const setCalculationModeRightMenuTab = simpleSet as
  redux.reducers.calculationMode.tabs.rightMenu;

export const rightMenu = setCalculationModeRightMenuTab(
  'SET_CALCULATION_MODE_RIGHT_MENU_TAB',
  'catalog'
);
